import { Helmet } from "react-helmet";
import { useState, useEffect } from "react";

function About() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div
      style={{
        background: "#2B2B2B",
        color: "white",
        padding: "40px 15px",
        minHeight: "100vh",
      }}
    >
      <Helmet>
        <title>About Us - G Bond</title>
      </Helmet>

      {/* HEADER */}
      <div style={{ textAlign: "center", marginBottom: "40px" }}>
        <h1 style={{ color: "#FFC107", fontSize: isMobile ? "26px" : "36px" }}>
          About G Bond
        </h1>
        <p style={{ fontSize: isMobile ? "14px" : "16px" }}>
          Manufacturer of tyre & tube repair materials and rubber compounds
        </p>
      </div>

      {/* INTRO */}
      <div
        style={{
          maxWidth: "900px",
          margin: "0 auto",
          textAlign: "center",
        }}
      >
        <p style={para}>
          G Bond is a trusted manufacturer of high-quality tyre repair materials
          and rubber compounds, serving dealers, wholesalers, and industrial
          buyers across India.
        </p>

        <p style={para}>
          Our products are designed for durability, performance, and reliability
          in real-world repair and industrial applications.
        </p>
      </div>

      {/* WHAT WE OFFER */}
      <div style={{ marginTop: "60px", textAlign: "center" }}>
        <h2 style={heading}>What We Manufacture</h2>

        <div
          style={{
            marginTop: "30px",
            display: "grid",
            gridTemplateColumns: isMobile
              ? "1fr"
              : "repeat(auto-fit, minmax(250px, 1fr))",
            gap: "20px",
            maxWidth: "1000px",
            marginInline: "auto",
          }}
        >
          {[
            "Tyre Repair Patches (Bias, Radial, OTR)",
            "Bonding Gum & Cushion Gum",
            "Puncture Repair Compounds",
            "Submersible Rubber Compounds",
            "Conveyor Belt Repair Materials",
          ].map((item, index) => (
            <div key={index} style={card}>
              {item}
            </div>
          ))}
        </div>
      </div>

      {/* WHY CHOOSE US */}
      <div style={{ marginTop: "60px", textAlign: "center" }}>
        <h2 style={heading}>Why Choose Us</h2>

        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            gap: "25px",
            marginTop: "30px",
          }}
        >
          {[
            ["✔ Quality Assurance", "Reliable performance"],
            ["✔ Industry Experience", "Strong market knowledge"],
            ["✔ Bulk Supply", "Pan India distribution"],
          ].map((item, i) => (
            <div key={i} style={{ maxWidth: "250px" }}>
              <h3>{item[0]}</h3>
              <p>{item[1]}</p>
            </div>
          ))}
        </div>
      </div>

      {/* VISION */}
      <div
        style={{
          marginTop: "60px",
          maxWidth: "900px",
          marginInline: "auto",
          textAlign: "center",
        }}
      >
        <h2 style={heading}>Our Vision</h2>

        <p style={para}>
          Our vision is to establish G Bond as a leading and trusted brand in
          tyre repair materials and rubber solutions, recognized for quality and
          reliability.
        </p>

        <p style={para}>
          We aim to continuously improve manufacturing, expand our product range,
          and support businesses with dependable and cost-effective solutions.
        </p>

        <p style={para}>
          Our goal is to grow as a nationwide and globally recognized brand while
          maintaining trust and performance at the core.
        </p>
      </div>

      {/* CTA */}
      <div style={{ marginTop: "60px", textAlign: "center" }}>
        <h2>Looking for Bulk Orders?</h2>
        <p>Contact us for dealership and wholesale pricing</p>

        <a
          href="https://wa.me/917412885533"
          target="_blank"
          rel="noopener noreferrer"
        >
          <button style={waBtn}>Contact on WhatsApp</button>
        </a>
      </div>
    </div>
  );
}

/* STYLES */
const heading = {
  color: "#FFC107",
};

const para = {
  marginTop: "15px",
  lineHeight: "1.8",
  fontSize: "15px",
};

const card = {
  background: "#1C1C1C",
  padding: "20px",
  borderRadius: "10px",
  textAlign: "center",
};

const waBtn = {
  marginTop: "15px",
  padding: "12px 25px",
  background: "#25D366",
  border: "none",
  color: "white",
  cursor: "pointer",
};

export default About;